import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityRevenueEstimate } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityRevenueEstimate";
import { formatDateFromISO } from "../../../core/util/functions";

export interface DisplaySecurityRevenueEstimateProps {
	symbol?: string;
}

export const DisplaySecurityRevenueEstimate: React.FunctionComponent<DisplaySecurityRevenueEstimateProps> = ({
	symbol,
}) => {
	const revenue_estimate = useDisplaySecurityRevenueEstimate(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4, getPercentString } = React.useContext(
		LocalizationContext
	);

	console.log(revenue_estimate)

	const [auth] = useAuth();


	return (
		<div className={style.root}>

			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("period")}</span>
				<span className={style.value}>
					{revenue_estimate?.period
						? getString(revenue_estimate.period as any)
						: ""}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimateDate")}</span>
				<span className={style.value}>
					{formatDateFromISO(revenue_estimate?.date)}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("numberOfAnalysts")}</span>
				<span className={style.value}> {getFormatedNumberString4(revenue_estimate?.number_of_analysts)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("avgEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString4(revenue_estimate?.avg_estimate)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("lowEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString4(revenue_estimate?.low_estimate)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("highEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString4(revenue_estimate?.high_estimate)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("yearAgoSales")}</span>
				<span className={style.value}> {getFormatedNumberString4(revenue_estimate?.year_ago_sales)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("salesGrowth")}</span>
				<span className={style.value}> {getPercentString(revenue_estimate?.sales_growth, false)}</span>
			</div>
		</div>
	);
};

